import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// Mui
import {
  AutocompleteInputChangeReason,
  Autocomplete as MuiAutocomplete,
  TextField as MuiTextField
} from '@mui/material';
// Utils
import { trimValue } from 'app/utilities/Utilities';
import useAuthorTypeGroupContext from './utils/useAuthorTypeGroupContext';

const TypeControl = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext();
  const { ControlProps, types } = useAuthorTypeGroupContext();

  const handleChange = (_:any, newValue:any) => {
    setValue('type', newValue);
  };

  const handleInputChange = (_:any, newValue:string, reason:AutocompleteInputChangeReason) => {
    if ( reason !== 'input' ) return;

    const trimedValue = trimValue(newValue);

    if ( !trimedValue ) return;

    setValue('type', newValue);
  };

  return (
    <Controller
      control={control} name="type" defaultValue={null}
      render={({ field }) => (
        <MuiAutocomplete
          {...field}
          disabled={ControlProps?.disabled || false}
          options={types}
          onChange={handleChange}
          onInputChange={handleInputChange}
          renderInput={(params) => (
            <MuiTextField
              {...params}
              label={t('labels.type')}
              size="small"
              margin="none"
            />
          )}
          freeSolo
          fullWidth
        />
      )}
    />
  )
}

export default TypeControl;
